import { buttonStyle } from 'components/buttons/buttonStyle';
import { ModalHeader } from 'components/modals/ModalHeader';
import { Button } from 'components/ui/button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { t } from 'utils/getTranslations';

interface Props {
    onSelectCompact: () => void;
    onSelectDetailed: () => void;
    onCancel: () => void;
}

/**
 * Lets the user pick which timecards export to download — the new "Compact"
 * ("Menetluskulude raport") variant or the full "Detailed" file.
 */
const TimecardExportVersionModal: React.FC<Props> = ({ onSelectCompact, onSelectDetailed, onCancel }) => {
    return (
        <>
            <ModalHeader title={t('timecards.export-version.title')} onCancel={onCancel} />
            <div className="flex flex-col gap-6 p-6">
                <p className="m-0 text-base">
                    <FormattedMessage id="timecards.export-version.question" />
                </p>
                <div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
                    <Button {...buttonStyle({ variant: 'contained', color: 'secondary' })} onClick={onSelectCompact}>
                        <FormattedMessage id="timecards.export-version.compact" />
                    </Button>
                    <Button {...buttonStyle({ variant: 'contained', color: 'secondary' })} onClick={onSelectDetailed}>
                        <FormattedMessage id="timecards.export-version.detailed" />
                    </Button>
                    <Button {...buttonStyle({ variant: 'outlined', color: 'secondary' })} onClick={onCancel}>
                        <FormattedMessage id="cancel" />
                    </Button>
                </div>
            </div>
        </>
    );
};

export default TimecardExportVersionModal;
